import type { SendMessageError } from '@/store/modules/aiAssistant/actions'

// The store resolves a failed send to an error code (it cannot import i18n):
// whoever sent the message shows the translated toast.
const SEND_ERROR_TOASTS = {
  network: { type: 'danger', fallback: 'Erreur serveur' },
  forbidden: {
    type: 'warning',
    fallback: "Tu n'as pas la permission d'utiliser l'assistant IA."
  },
  invalid: { type: 'warning', fallback: 'Message invalide.' },
  quota_exceeded: {
    type: 'warning',
    fallback: 'Quota IA mensuel atteint.',
    uniqId: 'ai-quota-exceeded'
  },
  rate_limited: {
    type: 'warning',
    fallback: 'Trop de requêtes, réessaie dans un instant.'
  },
  server: { type: 'danger', fallback: 'Erreur serveur' },
  interrupted: {
    type: 'danger',
    fallback: "La connexion avec l'assistant a été interrompue."
  },
  provider: {
    type: 'danger',
    fallback: "L'assistant n'a pas pu répondre, réessaie dans un instant."
  },
  conflict: {
    type: 'warning',
    fallback:
      'Les modifications en attente ont changé, vérifie-les avant de valider.'
  },
  stale: {
    type: 'warning',
    fallback: "Cette action n'est plus d'actualité."
  }
}

export function showSendError(
  vm: {
    $t: (key: string, fallback?: string) => string
    $h: Record<string, any>
  },
  { code, message }: SendMessageError
) {
  const { type, fallback, uniqId } = SEND_ERROR_TOASTS[code] as {
    type: string
    fallback: string
    uniqId?: string
  }
  const title = message ?? vm.$t(`global.ai_assistant.errors.${code}`, fallback)
  if (type === 'danger') {
    vm.$h.toastDanger(title, null, uniqId)
  } else {
    vm.$h.toastWarning(title, null, uniqId)
  }
}
